import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import {
  mapApprovalMemberCandidates,
  mapApprovalSettingsMutation,
  mapApprovalSupplier,
  mapApprovalTypeSettings,
  type ApprovalMemberCandidatesRaw,
  type ApprovalSupplierRaw,
  type ApprovalTypeSettingsRaw,
} from "../api/adapters";
import type { ApprovalSettingsDraft } from "../types";

const endpoint = "/approval/settings";

/** 读取全部登记过的审批类型及当前设置。 */
export async function fetchApprovalSettings() {
  const response = await httpClient.get<ApiEnvelope<ApprovalTypeSettingsRaw[]>>(endpoint);
  return requireData(response.data).map(mapApprovalTypeSettings);
}

/** 读取挑人用的部门与员工，只有能改设置的人可取。 */
export async function fetchApprovalMemberCandidates() {
  const response = await httpClient.get<ApiEnvelope<ApprovalMemberCandidatesRaw>>(`${endpoint}/member-candidates`);
  return mapApprovalMemberCandidates(requireData(response.data));
}

/** 按关键字搜能当结算主体的供应商，只有能改设置的人可取；空关键字不带参数。 */
export async function searchSettlementSuppliers(keyword: string) {
  const q = keyword.trim();
  const response = await httpClient.get<ApiEnvelope<ApprovalSupplierRaw[]>>(
    `${endpoint}/settlement-supplier-options`,
    { params: q ? { q } : {} },
  );
  return requireData(response.data).map(mapApprovalSupplier);
}

/** 整套保存一种审批类型的设置（主流程和全部分支）；带版本号，禁止自动重试非幂等写入。 */
export async function saveApprovalSettings(draft: ApprovalSettingsDraft) {
  const response = await httpClient.put<ApiEnvelope<ApprovalTypeSettingsRaw>>(
    `${endpoint}/${encodeURIComponent(draft.typeCode)}`,
    mapApprovalSettingsMutation(draft),
    { "axios-retry": { retries: 0 } },
  );
  return mapApprovalTypeSettings(requireData(response.data));
}

/** 校验统一响应，避免空载荷泄漏成属性读取错误。 */
function requireData<T>(envelope: ApiEnvelope<T>): T {
  if (envelope.code !== "OK" || envelope.data == null) throw new Error("审批设置接口返回无效数据。");
  return envelope.data;
}
